<template>
  <div class="flex main-div  main-height-width-login">
    <div class="brand-div-login">
      <img
        src="@/assets/capacio/login/login-girl.png"
        alt=""
        class="bottom-img"
      >
      <img
        src="@/assets/capacio/login/logo.svg"
        alt=""
        class="logo-img"
      >
    </div>
    <div class="w-1/2 login-form">
      <div class="flex login-form-in">
        <div class="w-3/5 login-div">
          <div
            v-if="sessionExpired"
            class="alert alert-warning mb-6"
          >
            <div class="flex-1">
              <svg
                fill="none"
                viewBox="0 0 24 24"
                class="w-6 h-6 mx-2 stroke-current"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
              <label>Your session has expired. Please log in again.</label>
            </div>
          </div>
          <h3 class="text-3xl font-semibold py-8">
            Welcome to Capacio
          </h3>
          <h4 class="text-base font-normal mb-8">
            Log in to Capacio via email.
          </h4>
          <login-form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from '../components/LoginForm.vue'

export default {
  components: {
    LoginForm
  },

  computed: {
    sessionExpired () {
      return this.$route.query.sessionExpired === '1'
    }
  }
}
</script>

<style lang="scss">
@import "../login.scss";
</style>
